// extracted by mini-css-extract-plugin
module.exports = {"link":"_25d45facb5--link--hOjVk"};